export default __webpack_public_path__ + "a24ecda56060003d46e9dcd357d48a60.png";